import React, { Component, PropsWithChildren } from 'react';

import styled from 'styled-components';

import Box from '../atoms/Box/Box';
import CSSMediaQuery, { ShowOn } from '../atoms/CSSMediaQuery/CSSMediaQuery';
import Divider from '../atoms/Divider/Divider';
import Text from '../atoms/Text/Text';

import { Align } from '@shared/enums/align';
import { Colors } from '@shared/interfaces/themes';
import { Transform } from '@shared/enums/transform';
import _isEqual from 'lodash/isEqual';
import { breakpoint } from 'theme';

const Wrapper = styled(Box)`
  ${breakpoint.m`
    padding-top: 2.5em;
    padding-left: 1.75em;
    padding-right: 1.75em;
    padding-bottom: 3.125em;
  `}

  ${breakpoint.lg`
    padding-top: 3.5em;
    padding-left: 0;
    padding-right: 0;
  `}
`;

const DividerExtend = styled(Divider)<{ centerDivider: boolean }>`
  ${props =>
    props.centerDivider &&
    `
    margin-left: auto;
    margin-right: auto;
  `}

  ${breakpoint.m`
    width: 17.375em;
  `}
`;

type TitleProps = {
  className?: string;
  align?: Align;
  showDividerOn?: ShowOn[];
  lineHeight?: string | number;
  color?: keyof Colors;
  weight?: 300 | 600;
  centerDivider?: boolean;
  transform?: Transform;
  size?: number;
  lgSize?: number;
};

export default class Title extends Component<PropsWithChildren<TitleProps>> {
  static defaultProps = {
    align: Align.Left,
    size: 2,
    color: 'scarpaFlow',
    showDividerOn: [ShowOn.Mobile, ShowOn.Tablet, ShowOn.Desktop],
    weight: 300,
  };

  shouldComponentUpdate(nextProps) {
    return !_isEqual(nextProps, this.props);
  }

  render() {
    return (
      <Wrapper
        className={this.props.className}
        pl={1.5}
        pr={1.5}
        pt={1.75}
        pb={1.75}
      >
        <Text
          color={this.props.color}
          component="h2"
          weight={this.props.weight}
          size={this.props.size}
          lgSize={this.props.lgSize}
          align={this.props.align}
          lineHeight={this.props.lineHeight}
          transform={this.props.transform}
        >
          {this.props.children}
        </Text>

        {this.props.showDividerOn.length !== 0 && (
          <CSSMediaQuery showOn={this.props.showDividerOn}>
            <Box pt={1.125}>
              <DividerExtend centerDivider={this.props.centerDivider} />
            </Box>
          </CSSMediaQuery>
        )}
      </Wrapper>
    );
  }
}
